import { gql } from '@apollo/client';

export const CREATE_ROLE = gql`
  mutation CreateRole($request: CreateRoleRequest!) {
    CreateRole(request: $request) {
      id
    }
  }
`;

export const UPDATE_ROLE = gql`
  mutation UpdateRole($id: String!, $request: UpdateRoleRequest!) {
    UpdateRole(id: $id, request: $request) {
      id
      slug
      description
    }
  }
`;

export const CREATE_CUSTOM_TEAM_ROLE = gql`
  mutation CreateCustomTeamRole($request: CreateCustomTeamRoleRequest!) {
    CreateCustomTeamRole(request: $request) {
      id
      slug
      name
      description
      type
      access_groups {
        ... on AccessGroup {
          id
          slug
          name
          description
          type
          rules {
            ... on PaginationResponse {
              count
            }
            ... on Rules {
              data {
                id
                name
                slug
                type
                scope
                created_at
                updated_at
                deleted_at
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CUSTOM_TEAM_ROLE = gql`
  mutation UpdateCustomTeamRole(
    $id: String!
    $request: UpdateCustomTeamRoleRequest!
  ) {
    UpdateCustomTeamRole(id: $id, request: $request) {
      id
      slug
      name
      description
      type
      access_groups {
        ... on AccessGroup {
          id
          slug
          name
          description
          type
          rules {
            ... on PaginationResponse {
              count
            }
            ... on Rules {
              data {
                id
                name
                slug
                type
                scope
                created_at
                updated_at
                deleted_at
              }
            }
          }
        }
      }
    }
  }
`;
